import { useRef } from 'react';

const services = [
  {
    id: 'ems',
    name: 'EMS Slim',
    benefit: '30 dakikada 20.000 kas aktivasyonu ile vücut şekillendirme',
    icon: 'ri-body-scan-line',
    color: 'from-[#FFB3C6] to-[#D4AF37]',
    badge: 'KAMPANYA',
    img: 'https://readdy.ai/api/search-image?query=EMS%20slim%20body%20contouring%20treatment%20at%20luxury%20beauty%20clinic%2C%20woman%20receiving%20electromagnetic%20muscle%20stimulation%20therapy%20on%20white%20treatment%20bed%2C%20clean%20professional%20medical%20spa%20environment%2C%20soft%20pink%20and%20gold%20aesthetic&width=400&height=300&seq=ems001&orientation=landscape',
  },
  {
    id: 'arc',
    name: 'Cilt Gençleştirme (ARC)',
    benefit: 'Cerrahi olmadan derin cilt yenileme ve kırışıklık giderme',
    icon: 'ri-sparkling-2-line',
    color: 'from-[#D4AF37] to-[#FFB3C6]',
    badge: null,
    img: 'https://readdy.ai/api/search-image?query=ARC%20skin%20rejuvenation%20treatment%20at%20premium%20beauty%20salon%2C%20woman%20with%20glowing%20radiant%20skin%20receiving%20facial%20technology%20treatment%2C%20luxurious%20spa%20setting%20with%20gold%20and%20pink%20ambiance&width=400&height=300&seq=arc001&orientation=landscape',
  },
  {
    id: 'lazer',
    name: 'Lazer Epilasyon',
    benefit: 'Kalıcı tüy azaltma, konforlu ve hızlı uygulama',
    icon: 'ri-flashlight-line',
    color: 'from-[#FFE5EC] to-[#FFB3C6]',
    badge: null,
    img: 'https://readdy.ai/api/search-image?query=laser%20hair%20removal%20treatment%20at%20elegant%20beauty%20clinic%2C%20professional%20laser%20device%20near%20smooth%20skin%2C%20clean%20white%20medical%20spa%20room%20with%20soft%20pink%20lighting&width=400&height=300&seq=lazer001&orientation=landscape',
  },
  {
    id: 'igneli',
    name: 'İğneli Epilasyon',
    benefit: 'Hassas bölgelerde kalıcı tüy yok etme çözümü',
    icon: 'ri-focus-3-line',
    color: 'from-[#FFF8F0] to-[#D4AF37]',
    badge: null,
    img: 'https://readdy.ai/api/search-image?query=electrolysis%20hair%20removal%20treatment%20at%20luxury%20beauty%20salon%2C%20professional%20electrolysis%20equipment%2C%20precision%20hair%20removal%20procedure%2C%20elegant%20spa%20atmosphere%20with%20cream%20and%20gold%20colors&width=400&height=300&seq=igneli001&orientation=landscape',
  },
  {
    id: 'makyaj',
    name: 'Kalıcı Makyaj',
    benefit: 'PhiBrows tekniği ile doğal görünümlü kalıcı kaş ve dudak',
    icon: 'ri-paint-brush-line',
    color: 'from-[#FFB3C6] to-[#FFF8F0]',
    badge: 'YENİ',
    img: 'https://readdy.ai/api/search-image?query=permanent%20makeup%20microblading%20procedure%20at%20premium%20beauty%20salon%2C%20close%20up%20of%20beautifully%20shaped%20eyebrows%20being%20done%20with%20microblading%20tool%2C%20elegant%20beauty%20clinic%20environment%2C%20soft%20pink%20and%20gold%20tones&width=400&height=300&seq=makyaj001&orientation=landscape',
  },
];

export default function QuickActionPanel() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const whatsappUrl = (service: string) =>
    `https://wa.me/905412190629?text=${encodeURIComponent(`Merhaba, ${service} hakkında bilgi almak istiyorum.`)}`;

  return (
    <section id="hizmetler" className="py-20 bg-[#FFF8F0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#D4AF37] text-xs font-semibold uppercase tracking-[0.3em] mb-3 block">Popüler Hizmetler</span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4">
            En Çok Tercih Edilen
            <br />
            <em className="text-[#D4AF37]">Güzellik Çözümlerimiz</em>
          </h2>
          <div className="w-16 h-0.5 bg-[#D4AF37] mx-auto mt-4" />
        </div>

        {/* Cards - Desktop Grid */}
        <div className="hidden md:grid grid-cols-3 gap-5">
          {/* Big card */}
          <div className="row-span-2 group relative rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-2 transition-all duration-500">
            <img
              src={services[0].img}
              alt={services[0].name}
              className="w-full h-full object-cover object-top min-h-[400px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            {services[0].badge && (
              <span className="absolute top-4 right-4 bg-gradient-to-r from-[#FFB3C6] to-[#D4AF37] text-white text-xs font-bold px-3 py-1 rounded-full">
                {services[0].badge}
              </span>
            )}
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm mb-3">
                <i className={`${services[0].icon} text-white text-lg`}></i>
              </div>
              <h3 className="font-serif text-white text-xl font-bold mb-1">{services[0].name}</h3>
              <p className="text-white/80 text-sm mb-4 leading-relaxed">{services[0].benefit}</p>
              <a
                href={whatsappUrl(services[0].name)}
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 bg-[#D4AF37] text-white text-xs font-semibold px-4 py-2.5 rounded-full hover:bg-[#B8962E] transition-colors whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                Detay Al &amp; Randevu Oluştur
              </a>
            </div>
          </div>

          {/* 4 smaller cards */}
          {services.slice(1).map((svc) => (
            <div
              key={svc.id}
              className="group relative rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-2 transition-all duration-500 h-48"
            >
              <img src={svc.img} alt={svc.name} className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
              {svc.badge && (
                <span className="absolute top-3 right-3 bg-[#D4AF37] text-white text-xs font-bold px-2.5 py-1 rounded-full">
                  {svc.badge}
                </span>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-serif text-white text-base font-bold mb-0.5">{svc.name}</h3>
                <p className="text-white/75 text-xs mb-3 line-clamp-2">{svc.benefit}</p>
                <a
                  href={whatsappUrl(svc.name)}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-1.5 bg-white/20 backdrop-blur-sm border border-white/40 text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line text-xs"></i>
                  Detay Al &amp; Randevu
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile: horizontal scroll */}
        <div
          ref={scrollRef}
          className="md:hidden flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
          style={{ scrollbarWidth: 'none' }}
        >
          {services.map((svc) => (
            <div
              key={svc.id}
              className="flex-shrink-0 w-64 snap-start group relative rounded-2xl overflow-hidden"
            >
              <img src={svc.img} alt={svc.name} className="w-full h-48 object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              {svc.badge && (
                <span className="absolute top-3 right-3 bg-[#D4AF37] text-white text-xs font-bold px-2.5 py-1 rounded-full">
                  {svc.badge}
                </span>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-serif text-white text-base font-bold mb-1">{svc.name}</h3>
                <p className="text-white/75 text-xs mb-3">{svc.benefit}</p>
                <a
                  href={whatsappUrl(svc.name)}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-1.5 bg-[#D4AF37] text-white text-xs font-semibold px-3 py-2 rounded-full whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line"></i>
                  Detay Al &amp; Randevu
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
